import L from 'leaflet'
import rulerControler from '../leaflet-controls/ruler-controler'

export default function () {
  this.map._container.focus()
  if (this.map.customControls.hasOwnProperty('square')) return;
  if (this.map.customControls.hasOwnProperty('ruler')) {
    this.map.removeControl(this.map.customControls.ruler)
  }
  const squareControl = rulerControler.extend({
    _square: null,
    _clicked: function (event) {
      const divCircle = L.divIcon({ className: 'cross-point', iconSize: [32, 32], iconAnchor: [16, 16]})
      const marker = L.marker(event.latlng, {
        icon: divCircle,
        draggable: true,
        keyboard: false,
        key: 'point'
      }).addTo(this._allLayers)

      marker.getElement().classList.add('shadow')
      marker.getElement().style.setProperty('--pseudo-backgroundcolor', this.options.defaultColor)
      marker.on('move', this._resizeSquare.bind(this))
      marker.on('remove', () => {
        this._allLayers.removeLayer(marker)
        this._resizeSquare()
      })
      this._resizeSquare(event.latlng)
    },
    _resizeSquare: function (latlng) {
      if (this._square) {
        const newPoints = this._allLayers.getLayers().map(layer => {
          return layer.getLatLng()
        })
        this._square.setLatLngs([newPoints])
      } else {
        this._square = L.polygon([latlng], { dashArray: '3, 6', color: this.options.defaultColor, weight: 2}).addTo(this._map)
        this._square.on('remove', (event) => {
          this._allLayers.eachLayer(layer => {
            layer.remove()
          })
          this._map.removeControl(event.target.options.control)
          this._square = null
        })

        this._createControl(this._square)
      }
      this._findInfo()
    },
    _mapMousemoving: function (event) {
      if (this._square) {
        const newPoints = this._allLayers.getLayers().map(layer => {
          return layer.getLatLng()
        })
        this._square.setLatLngs([newPoints.concat([event.latlng])])
      }
    },
    _findInfo: function () {
      if (!this._square.options.control) return;

      const currentConfig = this._map.options.mapConfig
      const coordinates = this._square.getLatLngs().reduce((coords, row) => {
        return coords.concat(row.map(coord => this.changeCoordinates(coord, currentConfig)))
      }, [])

      const value = this._conversionToScale(this._distance(coordinates), currentConfig)
      this._square.options.control.updateText(value + ' m<sup>2</sup>')
    },
    _distance: function (coordinates) {
      if (coordinates.length < 3) return 0

      return Math.abs(
        coordinates.reduce((value, coords, index) => {
          let first = 0
          let second = 0
          if (index + 1 >= coordinates.length) {
            first = coords.lat * coordinates[0].lng
            second = coordinates[0].lat * coords.lng
          } else {
            first = coords.lat * coordinates[index + 1].lng
            second = coordinates[index + 1].lat * coords.lng
          }

          return value + first - second
        }, 0)
      ) / 2
    },
    _conversionToScale: function (distance, { pointsPerMeter }) {
      return (distance / Math.pow(pointsPerMeter, 2)).toFixed(2)
    }
  })

  const square = new squareControl({
    id: 'square',
    vue: this,
    defaultColor: '#FF6E40',
    inactiveColor: 'grey'
  })

  square.addTo(this.map)
}